import { DefaultGlobalNotFound } from "@tanstack/react-router"
import { useMemo } from "react"
import cookie from "./legal/cookie.md?raw"
import dpa from "./legal/dpa.md?raw"
import privacy from "./legal/privacy.md?raw"
import subprocessors from "./legal/subprocessors.md?raw"
import terms from "./legal/terms.md?raw"
import { useLocale } from "@/base"
import { Markdown } from "@/ui"

type Props = {
  slug: string
}

export default function Legal({ slug }: Props) {
  const locale = useLocale()

  const content = useMemo(() => {
    switch (slug) {
      case "cookie":
        return cookie
      case "dpa":
        return dpa
      case "privacy":
        return privacy
      case "subprocessors":
        return subprocessors
      case "terms":
        return terms
    }
  }, [slug])

  // The docs cross-link each other with unprefixed paths (/legal/x); the pages
  // now live under /{locale}/legal/x, so prefix those links with the active
  // locale (keeps them in-language and resolvable to the prerender crawler).
  const localised = useMemo(
    () => content?.replaceAll("](/legal/", `](/${locale}/legal/`),
    [content, locale],
  )

  if (!localised) {
    return <DefaultGlobalNotFound />
  }

  return (
    <div className="p-8">
      <Markdown className="mx-auto">{localised}</Markdown>
    </div>
  )
}
